export const RANGE_PRICES = {
  amfiEik: [70113, 81840, 121132],
  arkitektPlus: [50600, 106300, 106600],
  signaturEkbacken: [100000, 190000, 200000],
  fagero: [56200, 117900, 111600],
  form: [50600, 106300, 102600],
  forte: [40398, 49734, 68641],
  herregard: [53272, 64552, 90139],
  herregardEik: [77822, 91701, 134434],
  horisont: [49481, 59449, 83564],
  line: [49481, 59449, 83564],
  lindo: [56200, 117900, 111700],
  viken: [53500, 109800, 109600],
  toniton: [59000, 121400, 120600],
  ramsvik: [53800, 110700, 109900],
  malevik: [44600, 91000, 89400],
  sand: [44003, 52519, 74212],
  scala: [49590, 59449, 83564],
  solidoHvit: [56887, 66735, 96944],
  squareEik: [72969, 85843, 126138],
  signatureFavn: [70097, 81825, 121135],
  uno: [39717, 45521, 68551],
  vidde: [32083, 37090, 54670],
  fjell: [44003, 61035, 74212],
  eikeli: [97685, 127887, 184274],
}

export const WORKTOP_PRICES = {
  laminate: [3073, 5300, 6956],
  solidTimber: [11480, 20087, 25697],
  granite: [0, 0, 0],
  stainless: [35830, 47400, 62600],
}
